import * as React from 'react';
import { observable, action } from 'mobx';
import { uniqueId } from '@app/src/common/helpers/uniqueId';
import Log from '@app/src/common/helpers/log';

export enum DialogActionType {
  cancel,
  submit,
}

export interface IModalProps {
  onClose: (operation: DialogActionType, payload?: unknown) => void;
}

export class Modal<T> {
  id = uniqueId();
  className?: string; // TODO: remove?
  Component: React.ComponentType<T>;
  props?: Omit<T, 'onClose'>;
}

export class ModalStoreModel {
  @observable modalList: Modal<any>[] = [];
  @observable isLoading = false;

  private _modalPromises: {
    resolve: (value: any) => void;
    reject: (value: any) => void;
  }[] = [];

  @action
  showModal<T extends IModalProps, S = any>(
    Component: React.ComponentType<T>,
    props?: Omit<T, 'onClose'>,
  ) {
    const modal = new Modal<T>();

    modal.Component = Component;
    modal.props = props;

    this.modalList.push(modal);

    return new Promise<{ operation: DialogActionType; payload: S }>(
      (resolve, reject) => this._modalPromises.push({ resolve, reject }),
    );
  }

  @action.bound
  closeModal(operation = DialogActionType.cancel, payload?: any) {
    const promise = this._modalPromises.pop();
    const result = { operation, payload };

    if (promise) {
      if (operation === DialogActionType.cancel) {
        promise.reject(result);
      } else {
        promise.resolve(result);
      }
    } else {
      Log.info('There are no promises in the list of modals');
    }

    this.modalList.pop();
  }

  @action
  closeAllModal() {
    while (this.modalList.length) {
      this.closeModal();
    }
  }
}

export default new ModalStoreModel();
